import { List, Datagrid, TextField, NumberField, BooleanField } from "react-admin";

export const OperatorList = () => (
  <List perPage={50}>
    <Datagrid bulkActionButtons={false}>
      <TextField source="operatorId" label="Operator ID" />
      <TextField source="operatorBaseUrl" label="Base URL" sx={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "0.8rem" }} />
      <NumberField source="oneShotTokenTtlSeconds" label="Token TTL (s)" />
      <NumberField source="sessionTimeoutTtlMinutes" label="Session TTL (min)" />
      <NumberField source="heartbeatIntervalSeconds" label="Heartbeat (s)" />
      <NumberField source="timeoutMs" label="Timeout (ms)" />
      <NumberField source="retryCount" label="Retries" />
      <NumberField source="retryDelayMs" label="Retry Delay (ms)" />
      <BooleanField source="suspended" label="Suspended" />
    </Datagrid>
  </List>
);
